import config from '@/config'

export const xjp_oos_domain = "https://awe-xjp.oss-ap-southeast-1.aliyuncs.com"
export const hk_oos_domain = "https://awepos.oss-cn-hongkong.aliyuncs.com"
export const paymentInStoreImageArr = [
  hk_oos_domain + "/b5713682-7493-41d5-b611-3cf2bd3a1f02.png",
  xjp_oos_domain + "/pc-en/img/payInStore.png"
]
export const updateFileUrl = (process.env.NODE_ENV === 'production' ? config.baseURL.prod : config.baseURL.dev) + '/api/v1/upload/oss/image'
/**
 * 订单转换为显示字段
 * @param {*} orderStaus
 * @param {*} payImage
 * @returns
 */
export function orderStatusToView(orderStaus, payImage) {
  switch (orderStaus) {
    case "1":
      if (payImage) {
        if (paymentInStoreImageArr.includes(payImage)) {
          return "Pay In Store"
        } else {
          return "Pay By Transfer Waiting For Review"
        }
      } else {
        return "Unpaid";
      }
    case "0":
    case "2":
    case "3":
    case "4":
    case "51":
    case "5":
    case "8":
      return "Paid";
    case "6":
    case "100":
    case "102":
    case "106":
      return "Unreceived";
    case "10":
      return "Canceled";
    case "7":
      return "Completed";
    case "98":
      return "Chargeback"
    default:

      return "Contact Customer Service"
  }
}
export function isMobile() {
  return document.body.clientWidth <= 1024
}
export function drawerSize() {
  if (document.body.clientWidth <= 768) {
    return "100%";
  } else if (
    document.body.clientWidth > 768 &&
    document.body.clientWidth <= 1024
  ) {
    return "50%";
  } else if (
    document.body.clientWidth > 1024 &&
    document.body.clientWidth < 1360
  ) {
    return "40%";
  } else {
    return "30%";
  }
}
/**
 * 图片压缩路径生成
 * @param {string} imgUrl
 * @param {string} height
 * @param {string,number} width
 * @returns
 */
export function oosImgSuffix(imgUrl, height = "100", width = "100") {
  if (imgUrl.includes("aliyuncs")) {
    return imgUrl ? `${imgUrl}?x-oss-process=image/resize,m_pad,h_${height},w_${width},color_ffffff` : ``
  } else {
    return imgUrl;
  }
}

export function countryDBtoView(countrydb) {
  return {
    "澳洲": 'Australia',
    "中国": "China",
    "台湾(中国)": "Taiwan",
    "香港(中国)": "Hongkong"
  }[countrydb] || countrydb
}

export function countryViewToDB(countryvo) {
  return {
    "Australia": '澳洲',
    "China": "中国",
    "Taiwan": "台湾(中国)",
    "Hongkong": "香港(中国)"
  }[countryvo] || countryvo
}
/**
    * 地址详情转化接口转显示层
    * @param {*} state
    * @param {*} getters
    * @returns
    */
export const addressDBtoView = (addressdb) => {
  let {
    addressId,
    contacts: addressee,
    contactPhone: phone,
    postCode: city,
    area,
    addressDetail: addressDetails,
    countryName,
  } = addressdb;
  let country = countryDBtoView(countryName)
  let cityName = area.split("-");
  return {
    addressId,
    addressee,
    phone,
    country,
    city,
    cityName,
    addressDetails
  };
}
/**
 * 地址详情转化显示层转接口
 * @param {*} state
 * @param {*} getters
 * @returns
 */
export const addressViewToDB = (addressvo) => {
  let {
    addressId,
    addressee: contacts,
    phone: contactPhone,
    city,
    cityName: cityNames,
    addressDetails: addressDetail,
    country
  } = addressvo;
  let zipCode = (city || []).join(",");
  let [provinceName, cityName, areaName] = cityNames;
  let countryName = countryViewToDB(country);
  let addType = { "China": "0", "Australia": "1" }[country] || "2"
  return {
    addressId,
    addType,
    contacts,
    contactPhone,
    countryName,
    provinceName,
    cityName,
    areaName,
    addressDetail,
    zipCode
  };
}
let messagesZtoE = {
  //common
  "参数错误": "Parameter error",
  //登录
  "账号或密码不能为空": "The account or password cannot be empty",
  "用户账户不存在": "The user account does not exist",
  "账户或密码错误": "The account or password is incorrect",
  //注册
  "验证码错误": "Verification code error",
  "注册失败": "Fail to register",
  "会员等级不存在": "Membership level does not exist",
  "手机号已注册": "Cell phone number registered",
  "参数不能为空": "The parameter cannot be empty",
  //goods
  "商品信息错误": "Product information error",
  "请选择物流公司": "Please select logistics company",
  "蜂鸟分箱失败, 请选择其他物流": "Beebird sorting failed, please choose other logistics",
  "收货地址不能为空": "The shipping address cannot be empty",
  "地址信息错误, 确认后提交": "Address information error, confirm and submit",
  "发送失败": "Fail to send",
  //order
  "订单不存在": "Order does not exist",
  "订单已取消, 请不要重复操作": "The order has been cancelled, please do not repeat the operation",
  "已支付订单不可取消， 如需退款请联系客服": "Paid orders cannot be cancelled, please contact customer service for refund",
  "用户信息错误": "User information error",
  "请选择配货方式": "Please select the distribution method",
  "商品数量不能小于0": "The quantity of goods cannot be less than 0",
  "商品已下架": "The merchandise has been removed from the shelves",
  "订单包含不同类型结算商品，确认后提交": "The order contains different types of settlement goods and is submitted upon confirmation",
  "商品库存数量不足": "The quantity of goods in stock is insufficient",
  "库存数量不足": "Shortage of stock",
  "一个订单只能提交同一个活动内的商品": "An order can only be submitted for items within the same activity",
  "提交订单失败": "Order submission failed",
  "超出可以购买最大数量": "More than the maximum quantity can be purchased",
  "商品未参加活动": "Merchandise did not participate in the event",
  "订单已存在": "Order already exists",
  "订单超时": "Order a timeout",
  "密码错误": "Wrong password",
  "请付款": "Please pay",
  "商品库存数量不足, 请选择其他门店": "The quantity of goods in stock is insufficient, please choose other stores",
  "请选择打包方式": "Please select a packing method",
  "请选择收货人地址": "Please select the consignee address",
  "请选择发货人地址": "Please select the shipper's address",
  "商品数量不能少于1": "The quantity of goods cannot be less than 1",
  "该商品已下架": "The item has been removed from the shelves",
  "商品数量错误": "Quantity error",
  //userInfo
  "用户登录已失效,请重新登录": "User login is invalid. Please login again",
  "账户状态异常请联系管理员": "If the account is abnormal, contact the administrator",
  "用户信息异常": "Abnormal User information",
  "原密码错误": "Old password incorrect",
  "密码只能为6位数字组成": "The password can contain only six digits",
  "身份证信息错误": "Id card information error",
  "账户余额不足": "Insufficient account balance",

  "根据订单金额添加积分": "Add credits based on the order amount",
  "反结账/退货/商城取消订单 撤销积分": "Reverse checkout/return/mall cancel order cancel points",
  "管理员调整": 'Administrator Adjustment'

}
let messagesEtoZ = () => {
  return Object.keys(messagesZtoE).reduce((acc, key) => {
    acc[obj[key]] = key;
    return acc;
  }, {});
}
export const escapeZtE = (message) => {
  return messagesZtoE[message] || message
}
export const escapeEtZ = (message) => {
  return messagesEtoZ[message] || message
}
export function awaitWarp(promise) {
  // console.log(promise)
  return promise.then(res => [null, res]).catch(err => [err, null])
}
/**
 * 根据商品Id计算虚拟欢迎度
 * @param {*} gId
 * @returns
 */
export function getGoodsScore(gId) {
  var sum = 0, reg = /^(\d)$/

  gId = gId.toString().split('')
  //太大了 削减到4位
  gId = gId.slice(gId.length - 4, gId.length)
  for (var i = 0; i < gId.length; i++) {
    if (!reg.test(gId[i])) {
      gId[i] = gId[i].toLowerCase().charCodeAt() - 87
    }
    sum += gId[i] * Math.pow(32, gId.length - i - 1)
  }
  sum = (5 - (sum % 3 / 10).toFixed(1)).toFixed(1)
  return sum

}



// WEBPACK FOOTER //
// ./src/utils/common.js